export interface IvyRelayStateDisplay {
  raw: number | undefined;
  label: string;
  description: string;
  icon: string;
  statusClass: 'open' | 'closed' | 'unknown';
}

export function getIvyRelayStateDisplay(relayState: number | undefined): IvyRelayStateDisplay {
  if (relayState === 0) {
    return {
      raw: 0,
      label: 'Relay open',
      description: 'No current flowing',
      icon: 'power_off',
      statusClass: 'open',
    };
  }
  if (relayState === 1) {
    return {
      raw: 1,
      label: 'Relay closed',
      description: 'Current flowing',
      icon: 'bolt',
      statusClass: 'closed',
    };
  }
  return {
    raw: relayState,
    label: 'Unknown',
    description: '—',
    icon: 'help_outline',
    statusClass: 'unknown',
  };
}
